import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import SEOTextSection from './components/SEOTextSection';

const SITE_URL = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && (import.meta as Record<string, Record<string, string>>).env.VITE_SITE_URL) || 'https://cssspreadsheet.cam';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  'mainEntity': [
    {
      '@type': 'Question',
      'name': 'What is a CSSBuy spreadsheet?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'A CSSBuy spreadsheet is a curated directory of verified seller links organized by product categories. These spreadsheets help shoppers using CSSBuy (a popular shopping agent) quickly find trusted sellers for shoes, clothing, accessories, and more without having to search through forums or unverified sources.',
      },
    },
    {
      '@type': 'Question',
      'name': 'How do I use the category links on this site?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Each category link on CSSSpreadsheet.cam directs you to a curated spreadsheet page on kaspreadsheet.com. Simply click the category you are interested in — Shoes, Hoodies, Jackets, Bags, or any other category — and you will be taken to a verified list of seller links for that product type.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Are all the seller links verified?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Yes. Every spreadsheet link shared through this directory is manually reviewed and regularly updated. We prioritize quality over quantity to ensure you are browsing reliable seller information rather than outdated or scam links.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Is CSSSpreadsheet.cam free to use?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Completely free. There are no sign-ups, subscriptions, or hidden fees. CSSSpreadsheet.cam is a public resource directory built to help the shopping agent community find trusted CSSBuy spreadsheet resources quickly and easily.',
      },
    },
    {
      '@type': 'Question',
      'name': 'Does this site support other shopping agents like Kakobuy or Superbuy?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'While our primary focus is CSSBuy spreadsheets, many of the seller links and categories are also compatible with other popular shopping agents including Kakobuy, Superbuy, and Oopbuy. The product links work across platforms as long as you use the correct agent.',
      },
    },
    {
      '@type': 'Question',
      'name': 'How often are the spreadsheets updated?',
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': 'Our directory is maintained regularly with weekly checks on link validity and seller status. We remove broken links, add new verified sellers, and update category organization to keep the resource fresh and reliable.',
      },
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={faqSchema as unknown as Record<string, unknown>} />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CategoryGrid />
      <SEOTextSection />
      <ArticleSection />
      <CTASection />
      <TestimonialSection />
      <FAQSection />
      <Footer />
    </main>
  );
}